import { Box, ButtonBase } from "@mui/material";
import { useTheme } from "@mui/material";
import Text from "../../../../theme/text/Text";
import { useEffect, useState } from "react";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";
import { useTranslation } from "react-i18next";
import { useCancelShipmentMutation, useGetOrderShipmentsQuery, useGetShipmentLabelMutationMutation, useGetShipmentLabelQuery, useActivateShipmentMutation, usePrintShipmentLabelMutation } from "../../../../../newapi/order/ordersSlice";
import { tokens, themeSettings } from "../../../../../theme";
import { ReactComponent as DhlLogo } from '../../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../../styles/svg/dpd.svg';
import { ReactComponent as PostNLLogo } from '../../../../../styles/svg/postnl.svg';
import { ReactComponent as BolLogo } from '../../../../../styles/svg/bol.svg';
import { ReactComponent as ParcelLogo } from '../../../../../styles/svg/parcel.svg';
import { ReactComponent as CirroLogo } from '../../../../../styles/svg/cirro.svg';
import { ReactComponent as UpsLogo } from '../../../../../styles/svg/ups.svg';
import { ReactComponent as IntrapostLogo } from '../../../../../styles/svg/intrapost.svg';
import { ReactComponent as SendcloudLogo } from '../../../../../styles/svg/sendcloud.svg';
import { ReactComponent as InnosendLogo } from '../../../../../styles/svg/innosend.svg';
import { ReactComponent as MyparcelLogo } from '../../../../../styles/svg/myparcel.svg';
import { ReactComponent as GlsLogo } from '../../../../../styles/svg/gls.svg';
import { ReactComponent as TrunkrsLogo } from '../../../../../styles/svg/trunkrs.svg';
import { ReactComponent as CycloonLogo } from '../../../../../styles/svg/cycloon.svg';
import { ReactComponent as HstLogo } from '../../../../../styles/svg/hst.svg';
import { ReactComponent as MyparcelcomLogo } from '../../../../../styles/svg/myparcelcom.svg';
import { ReactComponent as AmpereLogo } from '../../../../../styles/svg/ampere.svg';
import { ReactComponent as ZinepsLogo } from '../../../../../styles/svg/zineps.svg';
import { ReactComponent as VinologixLogo } from '../../../../../styles/svg/vinologix.svg';
import { ReactComponent as WegrowLogo } from '../../../../../styles/svg/wegrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import cx from 'classnames';
import Shbutton from "../../../../theme/buttons/Shbutton";
import { ShCopyButtonWithOwnChildren } from "../../../../theme/ShCopy";
import { Download, PictureAsPdf, Print, Link } from "@mui/icons-material";
import { getShipperColorSettingsByType } from "../../../../Streams/StreamShipperSettings";
import Subheading from "../../../../theme/text/Subheading";
import TopRight from "../../../../theme/positionals/TopRight";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import ShGridEmpty from "../../../../theme/datagrid2/Status/ShGridEmpty";
import { showToastMessage } from "../../../../../utils/toasts";
import { format } from "date-fns";
import { general_states, shipment_type } from "../../../../../utils/staticEnums";
import MConfirmDelete from "../../../Modals/MConfirmDelete";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../../Sidebar";
import MSelectLabel from "../../../Modals/MSelectLabel";
import MConfirmation from "../../../Modals/MConfirmation";
import { getTrackingLink } from "../../../../../utils/shipping";
import { useGetPickingSlipMutation, useUpdateShipmentMutation, useGetShipmentQuery } from "../../../../../newapi/order/shipmentsSlice";
import TurnedInIcon from '@mui/icons-material/TurnedIn';
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ShipmentStatusLabel from "../components/ShipmentStatusLabel";
import { downloadFile } from "../../../../../utils/downloadFile";

const ShipperLogoMap = {
    postnl: PostNLLogo,
    dhl: DhlLogo,
    dhlgermany: DhlGermanyLogo,
    dpd: DpdLogo,
    bol: BolLogo,
    parcel: ParcelLogo,
    cirro: CirroLogo,
    ups: UpsLogo,
    intrapost: IntrapostLogo,
    sendcloud: SendcloudLogo,
    innosend: InnosendLogo,
    innosendv2: InnosendLogo,
    myparcel: MyparcelLogo,
    gls: GlsLogo,
    trunkrs: TrunkrsLogo,
    cycloon: CycloonLogo,
    hst: HstLogo,
    myparcelcom: MyparcelcomLogo,
    ampere: AmpereLogo,
    zineps: ZinepsLogo,
    vinologix: VinologixLogo,
    wegrow: WegrowLogo,
};

const getShipperColorSettings = (shipperType) => {
    switch (shipperType) {
        case 'postnl':
            return { background: '#FFE9D6' };
        case 'dhl':
            return { background: '#FFF8F2' };
        case 'dhlgermany':
            return { background: '#FFF8F2' };
        case 'dpd':
            return { background: '#E0F7FA' };
        case 'bol':
            return { background: '#E8EAF6' };
        case 'cirro':
            return { background: '#4646f0' };
        case 'gls': 
            return { background: '#021ab2' };
        case 'trunkrs': 
            return { background: '#5b0bb6ff' };
        case 'cycloon': 
            return { background: '#c9152dff' };
        case 'hst': 
            return { background: '#e41b13ff' };
        default:
            return { background: '#FFFFFF' };
    }
};
 
const Shipments = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();
    const colors = tokens(theme.palette.mode);
    const [getLabelId, setGetLabelId] = useState(null);

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);

    // This view has two data sources: when opened from an order it lists every
    // shipment on that order; when opened for a single shipment (relation
    // shipments overview) it shows only that shipment.
    const { data: orderShipmentsData, isLoading: orderShipmentsIsLoading, isFetching: orderShipmentsIsFetching, isError: orderShipmentsIsError, refetch: refetchOrderShipments } = useGetOrderShipmentsQuery(props.data?.id, {
        skip: !props.data?.id || !!props.shipmentId
    });

    const { data: singleShipmentData, isLoading: singleShipmentIsLoading, isFetching: singleShipmentIsFetching, isError: singleShipmentIsError, refetch: refetchSingleShipment } = useGetShipmentQuery(props.shipmentId, {
        skip: !props.shipmentId
    });

    const shipmentsData = props.shipmentId
        ? (singleShipmentData ? [singleShipmentData] : undefined)
        : orderShipmentsData;
    const shipmentsIsLoading = props.shipmentId ? singleShipmentIsLoading : orderShipmentsIsLoading;
    const shipmentsIsFetching = props.shipmentId ? singleShipmentIsFetching : orderShipmentsIsFetching;
    const shipmentsIsError = props.shipmentId ? singleShipmentIsError : orderShipmentsIsError;
    const refetchShipments = props.shipmentId ? refetchSingleShipment : refetchOrderShipments;

    const hasModifyPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );

    const hasPreloadPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE_PRELOAD_SHIPMENTS])
    );


    const [getShipmentLabel, { data: shipmentLabelData, isLoading: shipmentLabelIsLoading, isError: shipmentLabelIsError }] = useGetShipmentLabelMutationMutation();
    const [printShipmentLabel, { isLoading: printShipmentLabelIsLoading }] = usePrintShipmentLabelMutation();
    const [cancelShipment, { data: cancelShipmentData, isLoading: cancelShipmentLoading, isError: cancelShipmentError }] = useCancelShipmentMutation();
    const [activateShipment, { isLoading: activateShipmentLoading }] = useActivateShipmentMutation();
   
    const [shipmentToReopen, setShipmentToReopen] = useState(null);
    const [shipmentToDelete,setShipmentToDelete] = useState(null);
    const [labelsModal, setLabelsModal] = useState({ open: false, labels: [], type: "" });
    const [open, setOpen] = useState(false);
    const [activateModalOpen, setActivateModalOpen] = useState(false);
    const [shipmentToActivate, setShipmentToActivate] = useState(null);
    const confirmActivate = async () => {
        if (!shipmentToActivate) return;

        await activateShipment({
            shipmentId: shipmentToActivate.id,
            workspaceId: selectedWorkSpace.id
        }).unwrap().then(res => {
            refetchShipments();
            setActivateModalOpen(false);
            setShipmentToActivate(null);
        }).catch(err => {
            console.error(err);
        });
    };

    const [updateShipment, { isLoading: updateShipmentLoading }] = useUpdateShipmentMutation();
    const reopenShipment = async ()  => {
        if (updateShipmentLoading) return;

        const updateObj = {
            id: shipmentToReopen.id,
            state: general_states.ACTIVE
        };

        await updateShipment(updateObj).unwrap().then(res => {
            refetchShipments();
        }).catch(err => {
            console.error(err);
        })
     }

    const confirmDelete = async ()  => {
        await cancelShipment(shipmentToDelete.id).unwrap().then(res => {
            refetchShipments();
            // props.setSelectedOrder((prevState) => {
            //     // Create a shallow copy of the shipments array
            //     const updatedShipments = [...prevState.shipments];
        
            //     const shipmentIndex = updatedShipments.findIndex(locShipment => locShipment.id === shipmentToDelete.id);
        
            //     if (shipmentIndex !== -1) {
            //         // Update the state of the found shipment to 'cancelled'
            //         updatedShipments[shipmentIndex] = {
            //             ...updatedShipments[shipmentIndex], // Keep other properties the same
            //             state: general_states.CANCELLED // Update the status to cancelled
            //         };
            //     }
        
            //     // Return the updated state with the modified shipments array
            //     return { ...prevState, shipments: updatedShipments };
            // });
            // console.log(res);
        }).catch(err => {
            console.error(err);
        })
     }
    const confirmDeleteModal = {
        open: open,
        setOpen: setOpen,
        confirm: confirmDelete
    }

    const [reopenModalOpen, setReopenModalOpen] = useState(false);
    const reopenModal = {
        open: reopenModalOpen,
        setOpen: setReopenModalOpen,
        confirm: confirmDelete
    }

 

    const renderShipperLogo = (shipperType) => {
        const LogoComponent = ShipperLogoMap[shipperType];
        return LogoComponent ? <LogoComponent className={shipperType} /> : null;
    };

    const handlePrintLabel = async (shipment) => {
        if (printShipmentLabelIsLoading) return;
        await printShipmentLabel({
            shipmentId: shipment.id,
            workspaceId: selectedWorkSpace?.id
        }).unwrap().then(() => {
            showToastMessage("success", t("label_sent_to_printer"));
        }).catch(err => {
            showToastMessage("error", t("label_print_failed"));
        });
    };

    return (
        <Box
            sx={{
                flexDirection:"column",
                padding:2,
                flex:1,
                width:1,
                // width: 'calc(50% - 12px)', // Subtract the gap from the total width
                display: 'flex',
                "@media screen and (max-width: 47.9375em)" : {
                    gap:1.5,
                    position:"relative",
                }
            }}
        >
            {shipmentsIsLoading && <ShTextSkeleton />}
            {shipmentsIsError && <Text color="error">{t('error.loading')}</Text>}

            {shipmentsData && (() => {
                const nonReturnTypes = ['standard', 'mailbox', 'pickup', 'relation'];
                const sortedShipments = [...shipmentsData].sort(
                    (a, b) => new Date(b.shipmentDate) - new Date(a.shipmentDate)
                );

                const nonReturnShipments = sortedShipments.filter(s => nonReturnTypes.includes(s.type));
                const returnShipments = sortedShipments.filter(s => s.type === 'return');
                const preloadedShipments = sortedShipments.filter(s => s.type === 'preloaded' && hasPreloadPrivilege && !isRelation);

                return (
                    <>

                    {/* Optionally add a visual separator for return shipments */}
                    {nonReturnShipments.length > 0 && (
                        <Subheading sx={{mb:1,}}>Zendingen</Subheading>
                    )}

                    {/* Non-return shipments */}
                    {nonReturnShipments.map((shipment, index) => {
                        let name = shipment?.shipper?.name;
                        let type = shipment?.shipper?.type;
                        let extraName = shipment?.externalShipperName ?? "";

                        if (selectedEnvironmentType === ENV_TYPES[200]) {
                        if (shipment?.shipper.type === 'cirro') {
                            const extNameLower = shipment?.externalShipperName.toLowerCase();
                            type = extNameLower.includes("dhl")
                            ? "dhl"
                            : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                            ? "postnl"
                            : "default";

                            name = extNameLower.includes("dhl")
                            ? "DHL"
                            : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                            ? "PostNL"
                            : shipment?.externalShipperName;

                            extraName = "";
                        } else if (shipment?.shipper.type === 'sendcloud') {
                            type = shipment?.externalShipperName.toLowerCase().includes("ups") ? "ups" : "dhl";
                            name = shipment?.externalShipperName;
                            extraName = "";
                        }
                        }

                        const colorSettings = getShipperColorSettingsByType(type);

                        return (
                            <ShipmentCard
                                key={"shipment-list" + index}
                                index={index}
                                name={name}
                                extraName={extraName}
                                setLabelsModal={setLabelsModal}
                                getTrackingLink={getTrackingLink}
                                shipment={shipment}
                                colorSettings={colorSettings}
                                setShipmentToDelete={setShipmentToDelete}
                                confirmDeleteModal={confirmDeleteModal}
                                reopenModal={reopenModal}
                                setShipmentToReopen={setShipmentToReopen}
                                selectedEnvironmentType={selectedEnvironmentType}
                                renderShipperLogo={renderShipperLogo}
                                getShipmentLabel={getShipmentLabel}
                                shipmentLabelIsLoading={shipmentLabelIsLoading}
                                handlePrintLabel={handlePrintLabel}
                                printShipmentLabelIsLoading={printShipmentLabelIsLoading}
                                hasModifyPrivilege={hasModifyPrivilege}
                                type={type}
                            />
                        );
                    })}

                    {/* Provisional shipments */}
                    {preloadedShipments.length > 0 && (
                        <Subheading sx={{mt:3,mb:1,}}>{t("provisional_shipments")}</Subheading>
                    )}

                    {preloadedShipments.map((shipment, index) => {
                        let name = shipment?.shipper?.name;
                        let type = shipment?.shipper?.type;
                        let extraName = shipment?.externalShipperName ?? "";

                        if (selectedEnvironmentType === ENV_TYPES[200]) {
                            if (shipment?.shipper.type === 'cirro') {
                                const extNameLower = shipment?.externalShipperName.toLowerCase();
                                type = extNameLower.includes("dhl")
                                ? "dhl"
                                : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                                ? "postnl"
                                : "default";

                                name = extNameLower.includes("dhl")
                                ? "DHL"
                                : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                                ? "PostNL"
                                : shipment?.externalShipperName;

                                extraName = "";
                            } else if (shipment?.shipper.type === 'sendcloud') {
                                type = shipment?.externalShipperName.toLowerCase().includes("ups") ? "ups" : "dhl";
                                name = shipment?.externalShipperName;
                                extraName = "";
                            }
                        }

                        const colorSettings = getShipperColorSettingsByType(type);

                        return (
                            <ShipmentCard
                                key={"shipment-preloaded-list" + index}
                                index={index}
                                name={name}
                                extraName={extraName}
                                setLabelsModal={setLabelsModal}
                                getTrackingLink={getTrackingLink}
                                shipment={shipment}
                                colorSettings={colorSettings}
                                setShipmentToDelete={setShipmentToDelete}
                                confirmDeleteModal={confirmDeleteModal}
                                reopenModal={reopenModal}
                                setShipmentToReopen={setShipmentToReopen}
                                selectedEnvironmentType={selectedEnvironmentType}
                                renderShipperLogo={renderShipperLogo}
                                getShipmentLabel={getShipmentLabel}
                                shipmentLabelIsLoading={shipmentLabelIsLoading}
                                handlePrintLabel={handlePrintLabel}
                                printShipmentLabelIsLoading={printShipmentLabelIsLoading}
                                type={type}
                                isPreloaded={true}
                                setShipmentToActivate={setShipmentToActivate}
                                setActivateModalOpen={setActivateModalOpen}
                            />
                        );
                    })}

                    {/* Return shipments */}
                    {returnShipments.length > 0 && (
                        <Subheading sx={{mt:3,mb:1,}}>Retour zendingen</Subheading>
                    )}

                    {/* Return shipments */}
                    {returnShipments.map((shipment, index) => {
                        let name = shipment?.shipper?.name;
                        let type = shipment?.shipper?.type;
                        let extraName = shipment?.externalShipperName ?? "";

                        if (selectedEnvironmentType === ENV_TYPES[200]) {
                            if (shipment?.shipper.type === 'cirro') {
                                const extNameLower = shipment?.externalShipperName.toLowerCase();
                                type = extNameLower.includes("dhl")
                                ? "dhl"
                                : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                                ? "postnl"
                                : "default";

                                name = extNameLower.includes("dhl")
                                ? "DHL"
                                : (extNameLower.includes("postnl") || extNameLower.includes("post-nl") || extNameLower.includes("post nl"))
                                ? "PostNL"
                                : shipment?.externalShipperName;

                                extraName = "";
                            } else if (shipment?.shipper.type === 'sendcloud') {
                                type = shipment?.externalShipperName.toLowerCase().includes("ups") ? "ups" : "dhl";
                                name = shipment?.externalShipperName;
                                extraName = "";
                            }
                        }

                        const colorSettings = getShipperColorSettingsByType(type);

                        return (
                            <ShipmentCard
                                key={"shipment-return-list" + index}
                                index={index}
                                name={name}
                                extraName={extraName}
                                setLabelsModal={setLabelsModal}
                                getTrackingLink={getTrackingLink}
                                shipment={shipment}
                                colorSettings={colorSettings}
                                setShipmentToDelete={setShipmentToDelete}
                                confirmDeleteModal={confirmDeleteModal}
                                reopenModal={reopenModal}
                                setShipmentToReopen={setShipmentToReopen}
                                selectedEnvironmentType={selectedEnvironmentType}
                                renderShipperLogo={renderShipperLogo}
                                getShipmentLabel={getShipmentLabel}
                                shipmentLabelIsLoading={shipmentLabelIsLoading}
                                handlePrintLabel={handlePrintLabel}
                                printShipmentLabelIsLoading={printShipmentLabelIsLoading}
                                type={type}
                            />
                        );
                    })}
                    </>
                );
            })()}




            {/* {shipmentsData && [...shipmentsData] // Create a shallow copy of the array
                            .sort((a, b) => new Date(b.shipmentDate) - new Date(a.shipmentDate)) // Sort by shipmentDate, descending
                            .map((shipment, index) => {
                let name = shipment?.shipper?.name;
                let type = shipment?.shipper?.type;
                let extraName = shipment?.externalShipperName ?? "";
                if(selectedEnvironmentType === ENV_TYPES[200]) {
                    if(shipment?.shipper.type === 'cirro') {
                        type = shipment?.externalShipperName.toLowerCase().includes("dhl") ? "dhl" : (shipment?.externalShipperName.toLowerCase().includes("postnl") || shipment?.externalShipperName.toLowerCase().includes("post-nl") || shipment?.externalShipperName.toLowerCase().includes("post nl")) ? "postnl" : "default";
                        name = shipment?.externalShipperName.toLowerCase().includes("dhl") ? "DHL" : (shipment?.externalShipperName.toLowerCase().includes("postnl") || shipment?.externalShipperName.toLowerCase().includes("post-nl") || shipment?.externalShipperName.toLowerCase().includes("post nl")) ? "PostNL" : shipment?.externalShipperName;
                        extraName = "";
                    } else if(selectedEnvironmentType === ENV_TYPES[200] && shipment?.shipper.type === 'sendcloud') {
                        type = shipment?.externalShipperName.toLowerCase().includes("ups") ? "ups" : "dhl";
                    name = shipment?.externalShipperName;
                        extraName = "";
                    }
                } 

                
                const colorSettings = getShipperColorSettingsByType(type);

                return (
                    <ShipmentCard 
                        key={"shipment-list"+index}
                        index={index}
                        name={name}
                        extraName={extraName}
                        setLabelsModal={setLabelsModal}
                        getTrackingLink={getTrackingLink}
                        shipment={shipment}
                        colorSettings={colorSettings}
                        setShipmentToDelete={setShipmentToDelete}
                        confirmDeleteModal={confirmDeleteModal}
                        selectedEnvironmentType={selectedEnvironmentType}
                        renderShipperLogo={renderShipperLogo}
                        getShipmentLabel={getShipmentLabel}
                        type={type}
                        // shipmentDate={shipmentDate}
                    />
                )
            })} */}
            {shipmentsData?.length === 0 && !shipmentsIsLoading && !shipmentsIsFetching &&
                <ShGridEmpty/> 
            }
            <MConfirmDelete
                open={confirmDeleteModal.open}
                handleClose={() => confirmDeleteModal.setOpen(false)}
                // data={confirmDeleteModal.data}
                data={shipmentToDelete?.trackingNumber}
                confirm={confirmDeleteModal.confirm}
                title={t("cancel_shipment")}
                content={t("are_you_sure_you_want_to_cancel_shipment")}
                confirmBtn={t("cancel")}
            />
            <MConfirmation
                open={activateModalOpen}
                handleClose={() => {
                    setActivateModalOpen(false);
                    setShipmentToActivate(null);
                }}
                confirm={confirmActivate}
                title={t("activate_shipment")}
                content={t("activate_shipment_confirmation_message")}
            />
            <MConfirmation
                open={reopenModalOpen}
                handleClose={() => {
                    setReopenModalOpen(false);
                    setShipmentToReopen(null);
                }}
                confirm={reopenShipment}
                title={t("activate_shipment")}
                content={t("reopen_shipment_message")}
            />
             <MSelectLabel
            open={labelsModal.open}
            handleClose={() => setLabelsModal({ ...labelsModal, open: false })}
            labels={labelsModal.labels}
            type={labelsModal.type}
        />
        </Box>
         
    );
}

export default Shipments;



const ShipmentCard = (props) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t,i18n} = useTranslation();

    const [getPickingSlip, { data: pickingSlipData, isLoading: pickingSlipLoading, isError: pickingSlipIsError }] = useGetPickingSlipMutation();
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const shipperDimensionsZeroButNotWeight = props.shipment.shipperWeight !== 0 && 
        props.shipment.shipperLength === 0 && 
        props.shipment.shipperHeight === 0 && 
        props.shipment.shipperWidth === 0;

    const shipperDimensionsZero = props.shipment.shipperWeight === 0 && 
        props.shipment.shipperLength === 0 && 
        props.shipment.shipperHeight === 0 && 
        props.shipment.shipperWidth === 0;
    
    const showStockhubDimensions = (!isRelation) || (isRelation) && (shipperDimensionsZero || shipperDimensionsZeroButNotWeight);
    const showDeliveryCompanyDimensions = (!isRelation) || (isRelation && (!shipperDimensionsZero || !shipperDimensionsZeroButNotWeight));
    
    return (
        <Box
            key={"props.shipment-list"+props.index}
            sx={{
                pb:3,
                ml:3.5,
                position:'relative',
                "&:before" : {
                    zIndex:2,
                    content:'""',
                    display:'block',
                    width:6,
                    height:6,
                    background: theme.palette.mode === "dark" ? colors.txt["softenedMore"] : colors.grey[400],
                    position:'absolute',
                    top:10,
                    left:-24,
                    borderRadius:1,
                },
                "&:after" : {
                    zIndex:1,
                    content:'""',
                    display:'block',
                    width:2,
                    height:1,
                    background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                    position:'absolute',
                    top:10,
                    left:-22,
                    borderRadius:1,
                }
            }}

        >
            <Box
                sx={{
                    display:"flex",
                    // justifyContent:'space-between',
                }}
            >
                <Text bold>

                    {new Date(props.shipment?.shipmentDate).toLocaleString(i18n.language, {
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    })}
                </Text>&nbsp;
                <Text italic>
                    {new Date(props.shipment?.shipmentDate).toLocaleString(i18n.language, {
                        day: '2-digit',
                        month: 'long'
                    })}

                </Text>
            </Box>
            <Box
                className={cx(``, {
                    'cancelled': props.shipment.state === general_states.CANCELLED,
                    'preloaded': props.isPreloaded,
                })}
                sx={{
                    // background: "#FFF8F2",
                    background:props.colorSettings ? props.colorSettings.background : colors.grey[100],
                    border:`1px solid ${props.colorSettings ? props.colorSettings.streamrulehover : colors.grey[200]}`,
                    borderRadius:3,
                    padding:2,
                    width:1,
                    opacity: props.isPreloaded ? 0.7 : 1,
                    // overflow:"hidden",
    
                    "& .postnl" : {
                        width:24,
                        height:24,
                    },
    
                    "& .dpd" : {
                        width:24,
                        height:24,
                    },
                    "& .dhl" : {
                        width:24,
                        height:24,
                    },
                    "& .dhlgermany" : {
                        width:24,
                        height:24,
                    },
                    "& .bol" : {
                        width:32,
                        // width:24,
                        height:16,
                    },
                    "& .cirro" : {
                        width:24,
                        height:24,
                    },
    
                    
                    "@media screen and (max-width: 47.9375em)" : {
                        pl:0,
                        pr:0,
                        pb:0,              
                        position:"relative"              
                    },
                    "&.cancelled" : {
                        background: colors.red[100],
                        border:`1px solid ${colors.red[200]}`,
                    }
                }}
            >
            {/* Header */}
                <Box
                    sx={{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"flex-start"
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            alignItems:"center",
                            "@media screen and (max-width: 47.9375em)" : {
                                alignItems:"flex-start",
                                px:2,
                            }
                        }}
                    >
                        {props.shipment.shipper &&
                            <Box
                                sx={{
                                    width:32,
                                    height:32,
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        // width:"unset",
                                        // height:"unset"
                                    }
                                }}
                            >
                                {props.renderShipperLogo(props.type)}
                            
                            </Box>
                        }
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    display:"none",
                                }
                            }}
                        >
                            <Subheading color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null} >{props.name}{props.extraName !== ''  && ` (${props.extraName})`}</Subheading>
                            {props.shipment.state === general_states.CANCELLED && (
                                <Box
                                    sx={{
                                        height:28,
                                        lineHeight:"28px",
                                        borderRadius:3,
                                        px:1.5,
                                        fontWeight:500,
                                        fontSize:12,
                                        fontFamily:"Roboto, sans-serif",
                                        border: `1px solid ${colors.red[400]}`,
                                        background: colors.red[400],
                                        color: themeSettings(theme.palette.mode).palette.red.contrastText,
                                    }}
                                >
                                    {t("cancelled")}
                                </Box>
                            )}
                        </Box>

                        {/* Mobile  */}
                        <Box
                            sx={{
                                display:"none",
                                "@media screen and (max-width: 47.9375em)" : {
                                    display:"flex",
                                    flexDirection:"column"
                                }
                            }}
                        >
                            <Box sx={{ display:"flex", alignItems:"center", gap:1, flexWrap:"wrap" }}>
                                <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null} >{props.name}{props.shipment?.shipper.type === 'cirro' && ` (${props.shipment?.externalShipperName})`}</Text>
                                {props.shipment.state === general_states.CANCELLED && (
                                    <Box
                                        sx={{
                                            height:24,
                                            lineHeight:"24px",
                                            borderRadius:3,
                                            px:1.5,
                                            fontWeight:500,
                                            fontSize:11,
                                            fontFamily:"Roboto, sans-serif",
                                            border: `1px solid ${colors.red[400]}`,
                                            background: colors.red[400],
                                            color: themeSettings(theme.palette.mode).palette.red.contrastText,
                                        }}
                                    >
                                        {t("cancelled")}
                                    </Box>
                                )}
                            </Box>
                            <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null}  bold>
                                {props.shipment?.trackingNumber}
                                {/* {new Date(props.shipment?.props.shipmentDate).toLocaleString(i18n.language, { dateStyle: 'short', timeStyle: 'short' })} */}
                            </Text>
                        </Box>

                    </Box>

                    {/* Hide button on mobile */}
                    <Box
                        sx={{
                            display:"flex",
                            gap:2,
                            "@media screen and (max-width: 47.9375em)" : {
                                display:"none",
                            }
                        }}
                    >
                        {props.isPreloaded &&
                            <Box
                                sx={{
                                    height:40,
                                    px:2,
                                    background: theme.palette.mode === "dark" ? colors.orange[300] : colors.orange[100],
                                    borderTopLeftRadius:6,
                                    borderTopRightRadius:12,
                                    borderBottomLeftRadius:12,
                                    borderBottomRightRadius:6,
                                    lineHeight:"40px",
                                    fontFamily:"Roboto, sans-serif",
                                    fontSize:"14px",
                                    color: theme.palette.mode === "dark" ? colors.orange[100] : colors.orange[400],
                                    fontWeight:500,
                                    display:"flex",
                                    alignItems:"center",
                                }}
                            >
                                {t("provisional")}
                            </Box>
                        }
                        {props.isPreloaded && props.shipment.state !== general_states.CANCELLED &&
                            <ButtonBase
                                sx={{
                                }}
                            >
                                <Box
                                    onClick={() => {
                                        props.setShipmentToActivate(props.shipment);
                                        props.setActivateModalOpen(true);
                                    }}
                                    sx={{
                                        background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                        color: "#fff",

                                        display:"flex",
                                        px:3,
                                        height:40,
                                        borderRadius:5,
                                        gap:3,
                                        fontSize:"14px",
                                        fontFamily:"Roboto, sans-serif",
                                        fontWeight:500,
                                        alignItems:"center",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            ml:"auto"
                                        }}
                                    >
                                    {t("activate_shipment")}
                                    </Box>
                                </Box>
                            </ButtonBase>
                        }
                        {props.shipment.state !== general_states.CANCELLED && !props.isPreloaded &&
                            <Shbutton
                                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                                isLoading={pickingSlipLoading}
                                onClick={async () => {
                                    if(!pickingSlipLoading){
                                        const response = await getPickingSlip(props.shipment.id).unwrap();
                                        // Decode base64 PDF from response.data and create blob URL
                                        const base64Data = response.data;
                                        const decodedData = atob(base64Data);
                                        const arrayBuffer = new ArrayBuffer(decodedData.length);
                                        const uint8Array = new Uint8Array(arrayBuffer);
                                        for (let i = 0; i < decodedData.length; i++) {
                                            uint8Array[i] = decodedData.charCodeAt(i);
                                        }
                                        const blob = new Blob([uint8Array], { type: 'application/pdf' });
                                        const pdfUrl = URL.createObjectURL(blob);
                                        window.open(pdfUrl, '_blank');
                                    }
                                }}
                                startIcon={<TurnedInIcon/>}
                                variant="contained"
                            >
                                {t("pickingslip")}
                            </Shbutton>
                        }
                        {!props.isPreloaded && !isRelation && props.shipment.state !== general_states.CANCELLED &&
                        <ButtonBase
                            sx={{
                            }}
                        >
                            <Box
                                onClick={() => props.handlePrintLabel(props.shipment)}
                                sx={{
                                    background: props.colorSettings ? props.colorSettings.streamrule : colors.grey[400],
                                    color: props.colorSettings ? props.colorSettings.base : colors.grey[400],

                                    display:"flex",
                                    px:3,
                                    height:40,
                                    borderRadius:5,
                                    gap:3,
                                    fontSize:"14px",
                                    fontFamily:"Roboto, sans-serif",
                                    fontWeight:500,
                                    alignItems:"center",
                                }}
                            >
                                <Box
                                    sx={{
                                        ml:"auto",
                                        display:"flex",
                                        alignItems:"center",
                                    }}
                                >
                                <Print/>
                                </Box>
                                <Box
                                    sx={{
                                        ml:"auto"
                                    }}
                                >
                                {t("label")}
                                </Box>
                            </Box>
                        </ButtonBase>
                        }
                        {!props.isPreloaded &&
                        <ButtonBase

                            sx={{
                            }}
                        >
                            <Box
                                className={cx('',{
                                    'cancelled': props.shipment.state === general_states.CANCELLED,
                                })}
                                onClick={async () => {
                                    if(!props.shipmentLabelIsLoading){
                                        await props.getShipmentLabel(props.shipment.id).unwrap().then(res => {
                                            if (res.labels?.length > 1) {
                                                // If multiple labels, open modal with buttons
                                                props.setLabelsModal({
                                                    open: true,
                                                    labels: res.labels,
                                                    type: res.type
                                                });
                                            } else if (res.labels?.length === 1) {
                                                // If single label, open directly
                                                const label = res.labels[0];
                                                if (res.type === "pdf") {
                                                    const decodedData = atob(label);
                                                    const arrayBuffer = new ArrayBuffer(decodedData?.length);
                                                    const uint8Array = new Uint8Array(arrayBuffer);
                                                    for (let i = 0; i < decodedData.length; i++) {
                                                        uint8Array[i] = decodedData.charCodeAt(i);
                                                    }
                                                    const blob = new Blob([uint8Array], { type: 'application/pdf' });
                                                    const pdfUrl = URL.createObjectURL(blob);
                                                    window.open(pdfUrl, '_blank');
                                                } else if (res.type === "link") {
                                                    window.open(label, '_blank');
                                                } else if (res.type === "zpl") {
                                                    downloadFile(URL.createObjectURL(new Blob([label], { type: 'text/plain' })), `${props.shipment?.trackingNumber || 'label'}.zpl`);
                                                }
                                            }
                                        }).catch(err => {
                                            // console.error(err);
                                        })
                                    }
                                }}
                                sx={{
                                    background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                    // border: `1px solid ${props.colorSettings ? props.colorSettings.base : colors.grey[400]}`,
                                    background: props.colorSettings ? props.colorSettings.streamrule : colors.grey[400],
                                    color: props.colorSettings ? props.colorSettings.base : colors.grey[400],

                                    display:"flex",
                                    px:3,
                                    height:40,
                                    borderRadius:5,
                                    gap:3,
                                    // color:"#fff",
                                    fontSize:"14px",
                                    fontFamily:"Roboto, sans-serif",
                                    fontWeight:500,
                                    alignItems:"center",
                                    "&.cancelled" : {
                                        background:colors.red[400],
                                        border:`2px solid ${colors.red[400]}`,
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        ml:"auto",
                                        display:"flex",
                                        alignItems:"center",
                                    }}
                                >
                                <Download/>
                                </Box>
                                <Box
                                    sx={{
                                        ml:"auto"
                                    }}
                                >
                                {t("label")}
                                </Box>
                            </Box>
                        </ButtonBase>
                        }

                        {!props.isPreloaded && props.type !== 'hst' &&
                        <ButtonBase
                            sx={{
                            }}
                        >
                            <Box

                                onClick={() =>{
                                    const link = props.getTrackingLink(props.shipment);
                                    window.open(link, "_blank");
                                }}
                                sx={{
                                        background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                        color: "#fff",

                                        display:"flex",
                                        px:3,
                                        height:40,
                                        borderRadius:5,
                                        gap:3,
                                        fontSize:"14px",
                                        fontFamily:"Roboto, sans-serif",
                                        fontWeight:500,
                                        alignItems:"center",
                                }}
                            >
                                <Box
                                    sx={{
                                        ml:"auto"
                                    }}
                                >
                                {t("tracking_link")}
                                </Box>
                                <Box
                                    sx={{
                                        ml:"auto",
                                        display:"flex",
                                        alignItems:"center",
                                    }}
                                >
                                <Link/>
                                </Box>
                            </Box>
                        </ButtonBase>
                        }

                        {!props.isPreloaded && props.type === 'hst' &&
                            <ShCopyButtonWithOwnChildren
                                value={props.getTrackingLink(props.shipment)}
                                sx={{
                                    alignItems:"center",
                                }}
                            >
                                <ButtonBase
                                    sx={{
                                        height:40,
                                        borderRadius:5,
                                        px:3,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                        color: "#fff",
                                        fontSize:14,
                                        fontWeight:500,
                                        fontFamily:"Roboto, sans-serif",
                                        gap:3,
                                    }}
                                >
                                    {t("tracking_link")}
                                </ButtonBase>
                            </ShCopyButtonWithOwnChildren>
                        }

                        {((!props.shipment.synced && props.shipment.type !== shipment_type.RETURN && props.shipment.state !== general_states.CANCELLED && props.selectedEnvironmentType === ENV_TYPES[100]) || props.isPreloaded) &&
                            <ButtonBase
                                onClick={async () => {
                                    props.setShipmentToDelete(props.shipment);
                                    props.confirmDeleteModal.setOpen(true);
                                }}
                                key={props.index}
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    width:40,
                                    height:40,
                                    borderRadius:5,
                                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[400],
                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                    fontWeight:"bold"
                                }}
                            >
                                <CloseIcon fontSize="small"/>
                            </ButtonBase>
                        }

                        {((!props.shipment.synced && props.shipment.type !== shipment_type.RETURN && props.shipment.state === general_states.CANCELLED && props.selectedEnvironmentType === ENV_TYPES[100]) || props.isPreloaded) &&
                            <ButtonBase
                                onClick={async () => {
                                    props.setShipmentToReopen(props.shipment);
                                    props.reopenModal.setOpen(true);
                                }}
                                key={props.index}
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    width:40,
                                    height:40,
                                    borderRadius:5,
                                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[400],
                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                    fontWeight:"bold"
                                }}
                            >
                                <AutorenewIcon fontSize="small"/>
                            </ButtonBase>
                        }
                    </Box>

                    <Box
                        sx={{
                            display:"none",
                            "@media screen and (max-width: 47.9375em)" : {
                                display:"unset",
                            }

                        }}
                    >
                        <TopRight>

                            {props.isPreloaded &&
                                <Box
                                    sx={{
                                        height:32,
                                        px:2,
                                        mr:1,
                                        mt:2,
                                        background: theme.palette.mode === "dark" ? colors.orange[300] : colors.orange[100],
                                        borderTopLeftRadius:6,
                                        borderTopRightRadius:12,
                                        borderBottomLeftRadius:12,
                                        borderBottomRightRadius:6,
                                        lineHeight:"32px",
                                        fontFamily:"Roboto, sans-serif",
                                        fontSize:"14px",
                                        color: theme.palette.mode === "dark" ? colors.orange[100] : colors.orange[400],
                                        fontWeight:500,
                                    }}
                                >
                                    {i18n.language === 'nl' ? 'Voorlopig' : 'Provisional'}
                                </Box>
                            }
                            {props.shipment.state !== general_states.CANCELLED && !props.isPreloaded &&
                                 <ButtonBase
                                    onClick={async () => {
                                        if(!pickingSlipLoading){
                                            const response = await getPickingSlip(props.shipment.id).unwrap();
                                            // Decode base64 PDF from response.data and create blob URL
                                            const base64Data = response.data;
                                            const decodedData = atob(base64Data);
                                            const arrayBuffer = new ArrayBuffer(decodedData.length);
                                            const uint8Array = new Uint8Array(arrayBuffer);
                                            for (let i = 0; i < decodedData.length; i++) {
                                                uint8Array[i] = decodedData.charCodeAt(i);
                                            }
                                            const blob = new Blob([uint8Array], { type: 'application/pdf' });
                                            const pdfUrl = URL.createObjectURL(blob);
                                            window.open(pdfUrl, '_blank');
                                        }
                                    }}
                                    key={props.index}
                                    sx={{
                                        mr:1,
                                        mt:2,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        width:32,
                                        height:32,
                                        borderRadius:5,
                                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[400],
                                        color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                        fontWeight:"bold"
                                    }}
                                >
                                    <TurnedInIcon fontSize="small"/>
                                </ButtonBase>
                            }
                            {((!props.shipment.synced && props.shipment.type !== shipment_type.RETURN && props.shipment.state !== general_states.CANCELLED && props.selectedEnvironmentType === ENV_TYPES[100]) || props.isPreloaded) &&
                                <ButtonBase
                                    onClick={async () => {
                                        props.setShipmentToDelete(props.shipment);
                                        props.confirmDeleteModal.setOpen(true);
                                    }}
                                    key={props.index}
                                    sx={{
                                        mr:2,
                                        mt:2,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        width:32,
                                        height:32,
                                        borderRadius:5,
                                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[400],
                                        color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                        fontWeight:"bold"
                                    }}
                                >
                                    <CloseIcon fontSize="small"/>
                                </ButtonBase>
                            }
                            {props.shipment.state === general_states.CANCELLED && 
                                <Box
                                    className={cx('',{
                                        'cancelled': props.shipment.state === general_states.CANCELLED,
                                    })}
                                    sx={{
                                        height:32,
                                        px:2,
                                        background:props.colorSettings ? props.colorSettings.streamrule : colors.grey[200],
                                        borderTopLeftRadius:6,
                                        borderTopRightRadius:12,
                                        borderBottomLeftRadius:12,
                                        borderBottomRightRadius:6,
                                        lineHeight:"32px",
                                        fontFamily:"Roboto, sans-serif",
                                        fontSize:"14px",
                                        color: props.colorSettings ? props.colorSettings.base : colors.grey[100],
                                        fontWeight:500,
                                        "&.cancelled" : {
                                            background:colors.red[100],
                                            color:colors.red[400],
                                        }
                                    }}
                                >
                                    {t("cancelled")}
                                </Box>
                            }

                        </TopRight>
                    </Box>

                </Box>

                <Box 
                    sx={{
                        pt:1,
                        display:"flex",
                        gap:8,
                        pl:6,
                        "@media screen and (max-width: 47.9375em)" : {
                            px:2,
                            pt:2,
                            gap:4,
                            pl:3,
                        }
                    }}
                >
                    <Box 
                        sx={{
                            display:"flex",
                            flexDirection:"column", 
                            "@media screen and (max-width: 47.9375em)" : {
                                display:"none"
                            }
                        }}
                    >
                        <Box sx={{display:"flex",flexDirection:"column"}}>
                            <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,.55)" : null}  >{t("shipped_date")}</Text>
                            <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null}  bold>
                                {/* {new Date(props.shipment?.props.shipmentDate).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })} */}
                                {new Date(props.shipment?.shipmentDate).toLocaleString(i18n.language, { dateStyle: 'short', timeStyle: 'short' })}
                            </Text>
                        </Box>
                        <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null} >{props.shipment?.trackingNumber}</Text>
                    </Box>

                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                            "@media screen and (max-width: 47.9375em)" : {
                                pl:5,
                            }
                        }}
                    >
                        <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,.55)" : null} light>{t('address')}</Text>
                        <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null}  bold>{props.shipment?.street} {props.shipment?.house_nr}{props.shipment?.house_nr_extra ? ` ${props.shipment?.house_nr_extra}` : ''}</Text>
                        <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,1)" : null} >{props.shipment?.postal} {props.shipment?.city}, {props.shipment?.country}</Text>
                    </Box>

                    {props.shipment?.shipmentStatus && (
                        <Box
                            sx={{
                                display:"flex",
                                flexDirection:"column",
                                alignItems:"flex-start",
                            }}
                        >
                            <Text color={theme.palette.mode === "dark"? "rgba(49,65,95,.55)" : null} light>{t('shipment_status')}</Text>
                            <Box sx={{ mt:0.5 }}>
                                <ShipmentStatusLabel shipment={props.shipment} />
                            </Box>
                        </Box>
                    )}

                </Box>

                <Box
                    sx={{
                        mt:2.5,
                        ml:6,
                        width:"auto",
                        p:2,
                        py:0.5,
                        background:props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        border:`1px solid ${props.colorSettings ? props.colorSettings.base : theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderRadius:3,
                        display:"flex",
                        gap:4,
                        pr:0.5,
                        pl:0.5,
                        "@media screen and (max-width: 47.9375em)" :{
                            flexDirection:'column',
                            gap:1,
                            ml:8,
                            mr:1.5,
                        }
                    }}
                >
                    {showStockhubDimensions && (
                        <Box
                            sx={{
                                display:"flex",
                                flexDirection:'column',
                                gap:1.5,
                                p:1,
                                pl:0,
                                pl:1.5,
                            }}
                        >

                            <Box
                                sx={{
                                }}
                            >
                                <Subheading
                                    sx={{
                                        color: tokens("light").txt["primary"],
                                    }}
                                >
                                    {t("stockhub_dimensions")}
                                </Subheading>
                            </Box>
                            <Box
                                sx={{
                                    display:"flex",
                                    gap:4,
                                    "@media screen and (max-width: 47.9375em)" :{
                                        flexDirection:"column",
                                        gap:1,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 47.9375em)" :{
                                            flexDirection:'row',
                                            justifyContent:"space-between",
                                            alignItems:'center',
                                        }
                                    }}
                                >
                                    <Text sx={{
                                        color:tokens("light").txt['secondary'],
                                    }}>{t("length")}</Text>
                                    <Text sx={{
                                        color:tokens("light").txt['primary'],
                                    }}>{props.shipment.length} {t("mm")}</Text>
                                </Box>

                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 47.9375em)" :{
                                            flexDirection:'row',
                                            justifyContent:"space-between",
                                            alignItems:'center',
                                        }
                                    }}
                                >
                                    <Text sx={{
                                        color:tokens("light").txt['secondary'],
                                    }}>{t("width")}</Text>
                                    <Text sx={{
                                        color:tokens("light").txt['primary'],
                                    }}>{props.shipment.width} {t("mm")}</Text>
                                </Box>

                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 47.9375em)" :{
                                            flexDirection:'row',
                                            justifyContent:"space-between",
                                            alignItems:'center',
                                        }
                                    }}
                                >
                                    <Text sx={{
                                        color:tokens("light").txt['secondary'],
                                    }}>{t("height")}</Text>
                                    <Text sx={{
                                        color:tokens("light").txt['primary'],
                                    }}>{props.shipment.height} {t("mm")}</Text>
                                </Box>

                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 47.9375em)" :{
                                            flexDirection:'row',
                                            justifyContent:"space-between",
                                            alignItems:'center',
                                        }
                                    }}
                                >
                                    <Text sx={{
                                        color:tokens("light").txt['secondary'],
                                    }}>{t("weight")}</Text>
                                    <Text sx={{
                                        color:tokens("light").txt['primary'],
                                    }}>{props.shipment.weight} {t("gr")}</Text>
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {showDeliveryCompanyDimensions && (
                        <Box
                            sx={{
                                background:props.colorSettings ? props.colorSettings.base : theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[400],
                                p:1,
                                flex:1,
                                borderRadius:2,
                                display:"flex",
                                flexDirection:'column',
                                gap:1.5,
                                pl:2,
                                "@media screen and (max-width: 47.9375em)" :{
                                    pl:1.5,
                                }
                            }}
                        >

                            <Box>
                                <Subheading
                                    sx={{
                                        color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                    }}
                                >
                                    {t("delivery_company_dimensions")}
                                </Subheading>
                            </Box>
                            {(!shipperDimensionsZero || !shipperDimensionsZeroButNotWeight) ? (
                            <Box
                                sx={{
                                    display:"flex",
                                    gap:4,
                                    "@media screen and (max-width: 47.9375em)" :{
                                        flexDirection:"column",
                                        gap:1,
                                    }
                                }}
                            >

                                {shipperDimensionsZeroButNotWeight ? (
                                    <>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("dimensions")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>
                                                {t("no_dimensions")}
                                            </Text>
                                        </Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("weight")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>{props.shipment.shipperWeight} {t("gr")}</Text>
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("length")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>{props.shipment.shipperLength} {t("mm")}</Text>
                                        </Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("width")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>{props.shipment.shipperWidth} {t("mm")}</Text>
                                        </Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("height")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>{props.shipment.shipperHeight} {t("mm")}</Text>
                                        </Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                "@media screen and (max-width: 47.9375em)" :{
                                                    flexDirection:'row',
                                                    justifyContent:"space-between",
                                                    alignItems:'center',
                                                }
                                            }}
                                        >
                                            <Text sx={{
                                                color: props.colorSettings ? props.colorSettings.streamrule : theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["softened"],
                                            }}>{t("weight")}</Text>
                                            <Text bold sx={{
                                                color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                            }}>{props.shipment.shipperWeight} {t("gr")}</Text>
                                        </Box>
                                    </>
                                )}
                               
                            </Box>
                            ): (
                                <Box>
                                    <Text sx={{
                                        color: props.colorSettings ? props.colorSettings.background : theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                    }}>
                                        {t("no_dimensions_or_weight")}
                                    </Text>
                                    
                                </Box>
                            )}

                        </Box>
                    )}
                </Box>
                {!props.isPreloaded &&
                <Box
                    sx={{
                        display:"none",
                        "@media screen and (max-width: 47.9375em)" : {
                            mt:3,
                            display:"flex",
                            width:1,
                        }
                    }}
                >

                    {props.shipment.state !== general_states.CANCELLED &&
                    <ButtonBase
                        sx={{
                            flex:1,
                            display:'block',
                        }}
                    >
                        <Box
                            onClick={() => props.handlePrintLabel(props.shipment)}
                            sx={{
                                display:"none",
                                "@media screen and (max-width: 47.9375em)" : {
                                    background: props.colorSettings ? props.colorSettings.streamrule : colors.grey[400],
                                    color: props.colorSettings ? props.colorSettings.base : colors.grey[400],

                                    display:"flex",
                                    px:3,
                                    height:40,
                                    borderBottomLeftRadius:12,
                                    fontSize:"14px",
                                    fontFamily:"Roboto, sans-serif",
                                    fontWeight:500,
                                    alignItems:"center",
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    ml:"auto",
                                    display:"flex",
                                    alignItems:"center",
                                }}
                            >
                            <Print/>
                            </Box>
                            <Box
                                sx={{
                                    ml:"auto"
                                }}
                            >
                                {t("label")}
                            </Box>
                        </Box>
                    </ButtonBase>
                    }
                    <ButtonBase
                        sx={{
                            flex:1,
                            display:'block',
                        }}
                    >
                        <Box
                            className={cx('',{
                                'cancelled': props.shipment.state === general_states.CANCELLED,
                            })}

                            onClick={async () => {
                                if(!props.shipmentLabelIsLoading){
                                    await props.getShipmentLabel(props.shipment.id).unwrap().then(res => {
                                        if (res.labels?.length > 1) {
                                            // If multiple labels, open modal with buttons
                                            props.setLabelsModal({
                                                open: true,
                                                labels: res.labels,
                                                type: res.type
                                            });
                                        } else if (res.labels?.length === 1) {
                                            // If single label, open directly
                                            const label = res.labels[0];
                                            if (res.type === "pdf") {
                                                const decodedData = atob(label);
                                                const arrayBuffer = new ArrayBuffer(decodedData?.length);
                                                const uint8Array = new Uint8Array(arrayBuffer);
                                                for (let i = 0; i < decodedData.length; i++) {
                                                    uint8Array[i] = decodedData.charCodeAt(i);
                                                }
                                                const blob = new Blob([uint8Array], { type: 'application/pdf' });
                                                const pdfUrl = URL.createObjectURL(blob);
                                                window.open(pdfUrl, '_blank');
                                            } else if (res.type === "link") {
                                                window.open(label, '_blank');
                                            } else if (res.type === "zpl") {
                                                downloadFile(URL.createObjectURL(new Blob([label], { type: 'text/plain' })), `${props.shipment?.trackingNumber || 'label'}.zpl`);
                                            }
                                        }
                                    }).catch(err => {
                                        // console.error(err);
                                    })
                                }
                            }}
                            sx={{
                                display:"none",
                                "@media screen and (max-width: 47.9375em)" : {
                                    background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                    // border: `1px solid ${props.colorSettings ? props.colorSettings.base : colors.grey[400]}`,
                                    background: props.colorSettings ? props.colorSettings.streamrule : colors.grey[400],
                                    color: props.colorSettings ? props.colorSettings.base : colors.grey[400],

                                    display:"flex",
                                    px:3,
                                    height:40,
                                    borderBottomLeftRadius:props.shipment.state === general_states.CANCELLED ? 12 : 0,
                                    borderBottomRightRadius:!(props.shipment.state !== general_states.CANCELLED && props.shipment.synced) ? 12 :0,

                                    fontSize:"14px",
                                    fontFamily:"Roboto, sans-serif",
                                    fontWeight:500,
                                    alignItems:"center",
                                    "&.cancelled" : {
                                        background:colors.red[400],
                                        border:`2px solid ${colors.red[400]}`,
                                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                                    }
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    ml:"auto",
                                    display:"flex",
                                    alignItems:"center",
                                }}
                            >
                            <Download/>
                            </Box>
                            <Box
                                sx={{
                                    ml:"auto"
                                }}
                            >
                                {t("label")}
                            </Box>
                        </Box>
                    </ButtonBase>

                        <ButtonBase
                            sx={{
                                flex:1,
                                display:'block',
                            }}
                        >
                            <Box

                                onClick={() =>{
                                    const link = props.getTrackingLink(props.shipment);
                                    window.open(link, "_blank");
                                }}
                                sx={{
                                    display:"none",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        background: props.colorSettings ? props.colorSettings.base : colors.grey[400],
                                        color: "#fff",
                                        display:"flex",
                                        px:3,
                                        height:40,
                                        borderBottomRightRadius:12,
                                        fontSize:"14px",
                                        fontFamily:"Roboto, sans-serif",
                                        fontWeight:500,
                                        alignItems:"center",
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        ml:"auto"
                                    }}
                                >
                                {t("tracking_link")}
                                </Box>
                                <Box
                                    sx={{
                                        ml:"auto",
                                        display:"flex",
                                        alignItems:"center",
                                    }}
                                >
                                <Link/>
                                </Box>
                            </Box>
                        </ButtonBase>
                </Box>
                }
            </Box>
        </Box>
    )
}